'use strict';

import angular from 'angular';

/**
 * Service pour gérer les données des autorisations d'exploitation
 */
angular.module('observatoireApp')
  .service('AutorisationsExploitationService', ['$http', '$q', function($http, $q) {
    
    /**
     * Récupère la liste des autorisations d'exploitation
     * @returns {Promise} Promesse contenant les données des autorisations
     */
    this.getAutorisations = function() {
      const deferred = $q.defer();
      
      $http.get('/api/autorisations-exploitation')
        .then(function(response) {
          // Traitement des dates si nécessaire
          let autorisations = response.data;
          console.log('Données brutes reçues de l\'API:', JSON.stringify(autorisations, null, 2));
          
          // Examiner le premier élément en détail s'il existe
          if (autorisations && autorisations.length > 0) {
            console.log('Premier élément détaillé:', JSON.stringify(autorisations[0], null, 2));
            console.log('Type de datePermis:', typeof autorisations[0].datePermis);
            console.log('Valeur de datePermis:', autorisations[0].datePermis);
            console.log('Type de dateExpirationPrevue:', typeof autorisations[0].dateExpirationPrevue);
            console.log('Valeur de dateExpirationPrevue:', autorisations[0].dateExpirationPrevue);
          }
          
          autorisations.forEach(function(autorisation) {
            // Fonction helper pour convertir une chaîne de date en objet Date valide
            function convertirDate(dateVal) {
              if (!dateVal) return null;
              
              // Si dateVal est déjà un objet Date, le retourner directement
              if (dateVal instanceof Date) {
                return dateVal;
              }
              
              // IMPORTANT: Gérer le cas où dateVal est un tableau [année, mois, jour, ...]
              // Format renvoyé par le backend Spring: [2015, 7, 18, 0, 0]
              if (Array.isArray(dateVal)) {
                // ATTENTION: dans les tableaux, le mois est 1-indexed, mais dans Date() il est 0-indexed
                // Donc on soustrait 1 du mois pour le constructeur Date
                const moisIndex = dateVal[1] - 1; 
                return new Date(dateVal[0], moisIndex, dateVal[2], dateVal[3] || 0, dateVal[4] || 0);
              }
              
              // S'assurer que dateVal est une chaîne de caractères pour les formats textuels
              const dateString = typeof dateVal === 'string' ? dateVal : String(dateVal);
              
              // Format: yyyy-MM-dd
              if (typeof dateString === 'string') {
                const simpleDateMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})/);
                if (simpleDateMatch) {
                  return new Date(simpleDateMatch[1], simpleDateMatch[2]-1, simpleDateMatch[3]);
                }
              }
              
              // Format: yyyy-MM-dd HH:mm:ss
              if (typeof dateString === 'string') {
                const match = dateString.match(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/);
                if (match) {
                  return new Date(match[1], match[2]-1, match[3], match[4], match[5], match[6]);
                }
              }
              
              // Essayer le constructeur Date standard en dernier recours
              const date = new Date(dateString);
              
              // Vérifier si la date est valide (pas NaN)
              if (!isNaN(date.getTime())) {
                return date;
              }
              
              return null;
            }
            
            // Conversion des chaînes de dates en objets Date pour Angular
            autorisation.datePermis = convertirDate(autorisation.datePermis);
            autorisation.dateDemande = convertirDate(autorisation.dateDemande);
            autorisation.dateDebutExploitation = convertirDate(autorisation.dateDebutExploitation);
            autorisation.dateExpirationPrevue = convertirDate(autorisation.dateExpirationPrevue);
            autorisation.dateExpirationProlongee = convertirDate(autorisation.dateExpirationProlongee);
            autorisation.dateResiliation = convertirDate(autorisation.dateResiliation);
            autorisation.dateDerniereModification = convertirDate(autorisation.dateDerniereModification);
          });
          
          deferred.resolve(autorisations);
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement des autorisations d\'exploitation:', error);
          // En cas d'erreur, on renvoie un tableau vide
          deferred.resolve([]);
        });
      
      return deferred.promise;
    };

    /**
     * Récupère les détails d'une autorisation spécifique
     * @param {number} id Identifiant de l'autorisation
     * @returns {Promise} Promesse contenant les détails de l'autorisation
     */
    this.getAutorisationDetails = function(id) {
      const deferred = $q.defer();
      
      $http.get(`/api/autorisations-exploitation/${id}`)
        .then(function(response) {
          // Traitement des dates si nécessaire
          let autorisation = response.data;
          
          // Fonction helper pour convertir une chaîne de date en objet Date valide
          function convertirDate(dateVal) {
            if (!dateVal) return null;
            
            // Si dateVal est déjà un objet Date, le retourner directement
            if (dateVal instanceof Date) {
              return dateVal;
            }
            
            // IMPORTANT: Gérer le cas où dateVal est un tableau [année, mois, jour, ...]
            // Format renvoyé par le backend Spring: [2015, 7, 18, 0, 0]
            if (Array.isArray(dateVal)) {
              // ATTENTION: dans les tableaux, le mois est 1-indexed, mais dans Date() il est 0-indexed
              // Donc on soustrait 1 du mois pour le constructeur Date
              const moisIndex = dateVal[1] - 1; 
              return new Date(dateVal[0], moisIndex, dateVal[2], dateVal[3] || 0, dateVal[4] || 0);
            }
            
            // S'assurer que dateVal est une chaîne de caractères pour les formats textuels
            const dateString = typeof dateVal === 'string' ? dateVal : String(dateVal);
            
            // Format: yyyy-MM-dd
            if (typeof dateString === 'string') {
              const simpleDateMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})/);
              if (simpleDateMatch) {
                return new Date(simpleDateMatch[1], simpleDateMatch[2]-1, simpleDateMatch[3]);
              }
            }
            
            // Format: yyyy-MM-dd HH:mm:ss
            if (typeof dateString === 'string') {
              const match = dateString.match(/(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})/);
              if (match) {
                return new Date(match[1], match[2]-1, match[3], match[4], match[5], match[6]);
              }
            }
            
            // Essayer le constructeur Date standard en dernier recours
            const date = new Date(dateString);
            
            // Vérifier si la date est valide (pas NaN)
            if (!isNaN(date.getTime())) {
              return date;
            }
            
            return null;
          }
          
          // Conversion des chaînes de dates en objets Date pour Angular
          autorisation.datePermis = convertirDate(autorisation.datePermis);
          autorisation.dateDemande = convertirDate(autorisation.dateDemande);
          autorisation.dateDebutExploitation = convertirDate(autorisation.dateDebutExploitation);
          autorisation.dateExpirationPrevue = convertirDate(autorisation.dateExpirationPrevue);
          autorisation.dateExpirationProlongee = convertirDate(autorisation.dateExpirationProlongee);
          autorisation.dateResiliation = convertirDate(autorisation.dateResiliation);
          autorisation.dateDerniereModification = convertirDate(autorisation.dateDerniereModification);
          
          // Pour les documents dans la collection
          if (autorisation.documents) {
            autorisation.documents.forEach(function(doc) {
              if (doc.date) doc.date = convertirDate(doc.date);
            });
          }
          
          // S'assurer que les propriétés existent pour éviter les erreurs dans le frontend
          if (!autorisation.clauses) {
            autorisation.clauses = [];
          }
          
          if (!autorisation.historique) {
            autorisation.historique = [];
          }
          
          deferred.resolve(autorisation);
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement des détails de l\'autorisation d\'exploitation:', error);
          deferred.reject(error);
        });
      
      return deferred.promise;
    };
  }])
  .name;
